import { ActivityVisualApi } from '@wiz-api/haiguang'

const activityVisual = new ActivityVisualApi()
/** ************************************************ 监控列表 **************************************** */
// let markerList = []
let cloudRender
let propPlayer
let propSceneId
let currentSelectedModel
const PROJECT_NAME = Wiz.globalSettings.globalConfig?.modelSetting?.folderName || 'SAAS'

// 获取项目计划可视化数据
const getVisualData = async () => {
  const [err, res] = await activityVisual.getActivityVisual({
    tenantId:
      localStorage.getItem('CurrentTenantId') ||
      JSON.parse(localStorage.getItem('CurrentUser'))?.TenantId ||
      '8b53295c-b059-4caf-8fc6-4a1d9e7807e9',
    sceneId: propSceneId,
    // sceneId: '3a12264f-44eb-6c39-f6fe-3f58b127c1cb',
    tagCode: currentSelectedModel.code,
    // tagCode: '外壳体.1',
  })
  // console.log(res, 'res')
  if (!err) {
    if (res.length) {
      const openEvent = new CustomEvent('openComponent', {
        detail: {
          toCom: { code: 'TaskInfo', origin: 'tag', originTagName: 'TaskInfo', name: '任务详情' },
          type: 'tags',
          props: {
            taskRow: res,
          },
        },
      })
      window.dispatchEvent(openEvent)
    } else {
      app.$message.warning('该模型未配置关联任务')
    }
  }
}

const watchMsg = async (data) => {
  // console.log('模型点选为：', data)
  if (!data) return
  currentSelectedModel = _.cloneDeep(data)
  // console.log('currentSelectedModel', data)
  if (!currentSelectedModel?.code) {
    return
  }
  getVisualData()
}

const create = async (player, sceneId, propcloudRender) => {
  cloudRender = propcloudRender
  propPlayer = player
  propSceneId = sceneId
  propPlayer.Native.ModelTree.EventSelectItemChanged.connect(watchMsg)
}

const destroy = async (player) => {
  player.Native.ModelTree.EventSelectItemChanged.disconnect(watchMsg)
}

const toggleDisplay = async (type) => {
  if (type) {
    player.Native.ModelTree.EventSelectItemChanged.connect(watchMsg)
  } else {
    player.Native.ModelTree.EventSelectItemChanged.disconnect(watchMsg)
  }
}

// 隐藏标签
const hidden = async () => {
  await toggleDisplay(false)
}

// 重新显示标签
const display = async () => {
  await toggleDisplay(true)
}

export default { create, destroy, hidden, display }
